import axios from '../../axios'

/*
 * 权限管理模块
 */

// 保存
export const save = (data) => {
    return axios({
        url: '/system/sysPrivilege/save',
        method: 'post',
        data
    })
}
// 删除
export const batchDelete = (data) => {
    return axios({
        url: '/system/sysPrivilege/delete',
        method: 'post',
        data
    })
}
// 列表页查询
export const list = (data) => {
    return axios({
        url: '/system/sysPrivilege/list',
        method: 'post',
        data
    })
};

// 查看
export const view = (data) => {
  return axios({
    url: '/system/sysPrivilege/view',
    method: 'post',
    data
  })
};

// 查询角色菜单集合
export const findRoleMenus = (params) => {
    return axios({
        url: '/system/sysPrivilege/findRoleMenus',
        method: 'post',
        params
    })
};

// 保存角色菜单集合
export const saveRoleMenus = (data) => {
    return axios({
        url: '/system/sysPrivilege/saveRoleMenus',
        method: 'post',
        data
    })
}

// 权限树导入
export const importPrivilegeTree = (data) => {
  return axios({
    url: '/system/sysPrivilege/importPrivilegeTree',
    method: 'post',
    data
  })
}

// 用户选择角色
export const selectRoles = (params) => {
  return axios({
    url: '/system/sysPrivilege/selectRoles',
    method: 'post',
    params
  })
}



// WEBPACK FOOTER //
// ./src/http/moudules/sys/privilege.js